import React, { useCallback, useMemo, useState } from 'react';
import { isNull } from 'lodash/fp';

import { DeleteButton } from '../../../shared/button/DeleteButton';
import { OverflowTooltip } from '../../../shared/tooltip/OverflowTooltip';
import styles from '../Workflow.module.scss';
import { ReportEmailAttachment } from '../store';
import { ReportAttachmentModal } from './ReportAttachmentModal';

interface ReportAttachmentProps {
    attachment: ReportEmailAttachment | null;
    updateReportAttachment: (attachment: ReportEmailAttachment | null) => void;
    isEditing: boolean;
    testId: string;
}

export const ReportAttachment: React.FC<ReportAttachmentProps> = ({ attachment, isEditing, testId, updateReportAttachment }) => {
    const [reportSelectModalOpen, setReportSelectModalOpen] = useState<boolean>(false);

    const openReportsModal = useCallback(() => setReportSelectModalOpen(true), []);
    const closeReportsModal = useCallback(() => setReportSelectModalOpen(false), []);

    const removeAttachment = useCallback(() => updateReportAttachment(null), [updateReportAttachment]);

    const buttonLabel = useMemo(() => isNull(attachment) ? 'Select Attachment' : attachment.templateName, [attachment]);
    const shouldShowRemove = useMemo(() => !isNull(attachment) && isEditing, [attachment, isEditing]);
    const buttonWidth = useMemo(() => shouldShowRemove ? 'calc(100% - 38px)' : '100%', [shouldShowRemove]);
    return (
        <div className={styles.reportAttachmentWrapper} data-testid={`${testId}-attachment-wrapper`}>
            <div className={styles.emailContentLabel} data-testid={`${testId}-attachment-label`}>Attachment: </div>
            <div className={styles.attachmentWrapper}>
                <button data-testid={`${testId}-attachment-button`} onClick={openReportsModal} className={styles.attachmentButton} disabled={!isEditing} style={{ width: buttonWidth }}>
                    <OverflowTooltip overlayText={buttonLabel} />
                </button>
                {shouldShowRemove &&
                    <DeleteButton onClick={removeAttachment} marginLeft='10px' />
                }
            </div>
            <ReportAttachmentModal isOpen={reportSelectModalOpen} closeModal={closeReportsModal} attachment={attachment} updateReportAttachment={updateReportAttachment} testId={`${testId}-attachment-modal`} />
        </div>
    );
};

